export default {
  mobile: 161,
  tablet: 273,
  desktop: 343
};
